<div [formGroup]="parentForm" class="autocomplete-container" [class.theme-web2]="theme === AutocompleteTheme.WEB_2">
  <div class="relative ps-xxsmall-b" matAutocompleteOrigin #origin="matAutocompleteOrigin">
    <label
      class="flex ps-xxsmall-b font-body-medium text-icon-secondary"
      [for]="controlName"
      [ngClass]="{
        'grey-600-text': !(ctrlField.invalid && ctrlField.touched) && theme === AutocompleteTheme.DEFAULT,
        'nordic-blue-400-text': !(ctrlField.invalid && ctrlField.touched) && theme === AutocompleteTheme.WEB_2,
        'error-900-text': ctrlField.invalid && ctrlField.touched,
      }"
    >
      <div class="flex-1">
        {{ translationPrefix + '.label' | finLocalization }}
        @if (isRequired) {
          <span class="flex-1 flex--nogrow"> *</span>
        }
      </div>
    </label>
    @if (loading$ | async) {
      <div class="absolute loader">
        <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT" />
      </div>
    }
    <input
      class="font-body-medium"
      autocomplete="off"
      [class.form-field-empty]="!(ctrlField.value || placeHolder)"
      [formControlName]="controlName"
      [id]="controlName"
      [matAutocomplete]="auto"
      [attr.placeholder]="placeHolder ? (placeHolder | finLocalization) : null"
      [matAutocompleteConnectedTo]="origin"
      [name]="controlName"
      [ngClass]="{
        'medium-type': theme === AutocompleteTheme.WEB_2,
        'ps-small': theme === AutocompleteTheme.WEB_2,
        'rounded-large': theme === AutocompleteTheme.WEB_2,
      }"
    />
    @if (theme !== AutocompleteTheme.WEB_2) {
      <span class="divider"></span>
    }
  </div>
  @if (ctrlField.invalid && ctrlField.touched) {
    <div class="error-label error-900-text signal-error-notification-border-icon-text font-body-small">
      @if (ctrlField.errors?.required) {
        <span>{{ translationPrefix + '.required' | finLocalization }}</span>
      }
      @if (ctrlField.errors?.forbiddenFormat || ctrlField.errors?.forbiddenLocation) {
        <span>{{ translationPrefix + '.pattern' | finLocalization }}</span>
      }
    </div>
  }
</div>
<mat-autocomplete
  #auto="matAutocomplete"
  [displayWith]="displayLocation"
  class="locations-autocomplete elevation-level-1 font-body-medium"
>
  @for (option of options$ | async; track option.locationCode) {
    <mat-option [value]="option">({{ option.locationCode }}) {{ option.title }}</mat-option>
  }
</mat-autocomplete>
<div aria-live="polite" class="result-helper is-vishidden">
  @if (autocompleteHelperState$ | async; as helperState) {
    @switch (helperState.kind) {
      @case ('results') {
        <span tabindex="-1">
          {{
            'SERVICE_FORMS.NTServiceForms.helpers.autocomplete.results'
              | finLocalization: { amount: helperState.amount }
          }}
        </span>
      }
      @case ('empty') {
        <span tabindex="-1">
          {{ 'SERVICE_FORMS.NTServiceForms.helpers.autocomplete.noResults' | finLocalization }}
        </span>
      }
    }
  }
  @if (ctrlField.invalid && ctrlField.touched) {
    <div>
      @if (ctrlField.errors?.required) {
        <span tabindex="-1">{{ translationPrefix + '.required' | finLocalization }}</span>
      }
      @if (ctrlField.errors?.forbiddenFormat || ctrlField.errors?.forbiddenLocation) {
        <span tabindex="-1">{{ translationPrefix + '.pattern' | finLocalization }}</span>
      }
    </div>
  }
</div>
